import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HasPermissionDirective, ImageIconDirective, NumberOnlyDirective, PasswordEyeDirective, ShowLoaderDirective } from '.';
import { DisableCopyPasteDirective } from './disable-copy-paste.directive';
import { DragAndDropFileDirective } from './drag-and-drop-file.directive';
import { FillHeightDirective } from './fill-height.directive';
import { ImageLoaderDirective } from './image-loader.directive';
import { ItemHoverDirective } from './item-hover.directive';
import { NumericOnlyDirective } from './numeric-only.directive';

const DIRECTIVES = [
  PasswordEyeDirective,
  ImageIconDirective,
  ShowLoaderDirective,
  ImageLoaderDirective,
  ItemHoverDirective,
  DisableCopyPasteDirective,
  HasPermissionDirective,
  DragAndDropFileDirective,
  FillHeightDirective,
  NumericOnlyDirective,
  NumberOnlyDirective
];

@NgModule({
  declarations: [...DIRECTIVES],
  imports: [CommonModule],
  exports: [...DIRECTIVES]
})
export class DirectivesModule {}
